export default "__VITE_ASSET__BlmL35NF__"